import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#465869",
  },
}));

export default styles;
